module.exports = __webpack_public_path__ + "img/portrait-037.ebd1a45b.jpg";